<template>
  <div class="new-guidelines">
    <div class="header-back">
      <div class="filter"></div>
      <img :src="img" alt="" class="img" />

      <div class="progress">
        <div class="bar">
          <svg width="100%" height="12" style="overflow:visible">
            <defs>
              <g id="circle1" y="0">
                <circle cx="0" cy="6" r="6" fill="#FFF"></circle>
                <circle cx="0" cy="6" r="4" fill="#009FFF"></circle>
              </g>
              <g id="text1" transform="translate(-32,0)" fill="#71C9FF">
                <rect x="0" y="-36" width="64" height="24" rx="5" ry="5" ></rect>
                <polygon points="25 -12, 39 -12, 32 -5"></polygon>
                <text x="6" y="-20" fill="#FFF" text-anchor="start" style="font-weight:400; font-size: 12px;">员工设置</text>
              </g>
            </defs>
            <line
              x1="0"
              x2="100%"
              y1="6"
              y2="6"
              stroke-linecap="round"
              stroke-width="6"
              stroke="#FFF"
            ></line>
            <line
              :x1="rate"
              x2="100%"
              y1="6"
              y2="6"
              stroke-linecap="round"
              stroke-opacity="0.8"
              stroke-width="6"
              stroke="#88D2FF"
            ></line>
            <use href="#circle1" :x="rate"></use>
            <use href="#text1" :x="rate"></use>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img from './guide.png';

export default {
  name: 'new-guidelines',
  data() {
    return {
      pageTitle: '新手指引',
      img,
      rate: '30%',
    };
  },
  computed: {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.new-guidelines {
  background: #ecfaff;
  .header-back {
    height: calc(var(--gap) * 224);
    position: relative;
    overflow: hidden;
    .filter {
      width: 200px;
      height: 29px;
      position: absolute;
      top: 0;
      left: 0;
      background: #bffbed;
      filter: blur(50px);
    }
    .img {
      position: absolute;
      right: 10px;
      top: -25px;
      width: 208px;
    }
    .progress {
      margin: 142px 16px 0;
      border-radius: 8px;
      height: 82px;
      background: linear-gradient(270deg, #88d2ff 0%, #009fff 100%);
      position: relative;
      z-index: 2;
      overflow: hidden;
      .bar {
        margin: 42px 16px 0;
      }
    }
  }
}
</style>
